(() => {
  'use strict';

  const VERSION = 'CANFOTO-ASAMA-04B-HOME-9-PROFILE-R1';
  const ROOT_SELECTOR = '.cf-home-hero[data-cf-home-experience="1"]';

  const FAMILY = Object.freeze({
    'cf-editorial':'slider',
    'cf-newsroom':'slider',
    'cf-chrome':'slider',
    'cf-redaxis':'slider',
    'cf-magazine':'storyrail',
    'cf-retrofuture':'storyrail',
    'cf-cinema':'storyrail',
    'cf-nature':'chapters',
    'cf-hyperpop':'chapters'
  });

  function profile() {
    return document.documentElement.getAttribute('data-cf-theme') || 'cf-editorial';
  }

  function familyFor(id) {
    return FAMILY[id] || 'slider';
  }

  function boot(root) {
    if (!root || root.dataset.cfHomeReady === '1') return;
    root.dataset.cfHomeReady = '1';

    const copies = Array.from(root.querySelectorAll('[data-cf-home-copy-slide]'));
    const media = Array.from(root.querySelectorAll('[data-cf-home-media-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-cf-home-dot]'));

    if (copies.length !== 2 || media.length !== 2 || dots.length !== 2) {
      root.dataset.cfHomeReady = 'invalid';
      return;
    }

    let index = 0;
    let timer = 0;
    let currentFamily = 'slider';
    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

    const activate = (next) => {
      index = next === 1 ? 1 : 0;
      copies.forEach((node, i) => node.classList.toggle('is-active', i === index));
      media.forEach((node, i) => node.classList.toggle('is-active', i === index));
      dots.forEach((node, i) => {
        const active = i === index;
        node.classList.toggle('is-active', active);
        node.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    };

    const stop = () => {
      if (timer) clearInterval(timer);
      timer = 0;
    };

    const start = () => {
      stop();
      if (currentFamily !== 'slider' || reduce || document.hidden) return;
      timer = setInterval(() => activate(index ? 0 : 1), 6500);
    };

    const applyProfile = (id) => {
      currentFamily = familyFor(id);
      root.dataset.cfHomeFamily = currentFamily;
      root.dataset.cfHomeProfile = id;
      activate(0);
      start();
    };

    dots.forEach((dot, i) => dot.addEventListener('click', () => {
      activate(i);
      start();
    }));

    document.addEventListener('visibilitychange', start);
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    window.addEventListener('canfoto:experience-change', (event) => {
      applyProfile(event?.detail?.current || profile());
    });

    applyProfile(profile());

    root.__CANFOTO_HOME_EXPERIENCE__ = Object.freeze({
      version: VERSION,
      familyMap: FAMILY,
      getIndex: () => index,
      getFamily: () => currentFamily,
      activate
    });
  }

  const run = () => document.querySelectorAll(ROOT_SELECTOR).forEach(boot);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once:true });
  } else {
    run();
  }

  window.debugCanFotoHomeProfiles = () => {
    const root = document.querySelector(ROOT_SELECTOR);
    const id = profile();
    const expectedFamily = familyFor(id);
    const canonical = document.querySelector('link[rel="canonical"]')?.href || null;
    const old = document.querySelector('[id*="custom_liquid_jekNmR"]');

    const result = {
      ok: Boolean(
        root &&
        root.dataset.cfHomeReady === '1' &&
        root.dataset.cfHomeFamily === expectedFamily &&
        root.dataset.cfHomeProfile === id &&
        root.querySelectorAll('[data-cf-home-copy-slide]').length === 2 &&
        root.querySelectorAll('[data-cf-home-media-slide]').length === 2 &&
        root.querySelectorAll('[data-cf-home-dot]').length === 2 &&
        (!old || getComputedStyle(old).display === 'none') &&
        canonical === 'https://www.canfoto.com/'
      ),
      version: VERSION,
      profile: id,
      family: root?.dataset.cfHomeFamily || null,
      expectedFamily,
      ready: root?.dataset.cfHomeReady || null,
      copySlides: root?.querySelectorAll('[data-cf-home-copy-slide]').length || 0,
      mediaSlides: root?.querySelectorAll('[data-cf-home-media-slide]').length || 0,
      dots: root?.querySelectorAll('[data-cf-home-dot]').length || 0,
      oldSliderHidden: old ? getComputedStyle(old).display === 'none' : null,
      canonical
    };

    console.log(result);
    return result;
  };
})();
(() => {
  'use strict';

  const VERSION = 'CANFOTO-PERFORMANCE-P1-C-R2-HOME-CONTROLS-OPTIONAL-OWNER-R1';
  const STATE_VERSION = 'CANFOTO-PERFORMANCE-P1-C-OBSERVER-CONSOLIDATION-R2';
  const GEOMETRY_EVENTS = Object.freeze([
    'load',
    'canfoto:unified-product-card-ready',
    'canfoto:experience-change',
    'shopify:section:load'
  ]);

  const p1cState = window.CANFOTO_P1C_OBSERVER_CONSOLIDATION_STATE =
    window.CANFOTO_P1C_OBSERVER_CONSOLIDATION_STATE || {
      version: STATE_VERSION,
      makeup: {},
      homeControls: {}
    };

  // Upgrade shared state version even when Makeup controller initialized it first.
  p1cState.version = STATE_VERSION;

  function publishState(nora, backTop, footer, bound) {
    const pairCoherent = Boolean(nora) === Boolean(backTop);
    const applicable = Boolean(nora && backTop);

    p1cState.homeControls = {
      owner: 'OPTIONAL_HOME_CONTROL_OWNER',
      applicable,
      pairCoherent,
      noraPresent: Boolean(nora),
      backTopPresent: Boolean(backTop),
      footerPresent: Boolean(footer),
      bound: Boolean(bound),
      documentResizeObserverCount: 0,
      windowScrollListenerCount: bound ? 1 : 0,
      windowResizeListenerCount: bound ? 1 : 0,
      footerIntersectionObserverCount:
        bound && footer && 'IntersectionObserver' in window ? 1 : 0,
      geometryLifecycleEvents: applicable ? [...GEOMETRY_EVENTS] : [],
      notApplicableReason:
        applicable ? null :
        (!nora && !backTop ? 'CONTROLS_NOT_RENDERED' : 'CONTROL_PAIR_INCOMPLETE')
    };

    return p1cState.homeControls;
  }

  function exposeDebug(nora, backTop, footer) {
    window.debugCanFotoHomeSealedControls = () => {
      const state = p1cState.homeControls || {};
      const applicable = state.applicable === true;
      const pairCoherent = state.pairCoherent === true;

      const result = {
        version: VERSION,
        observerConsolidationVersion: p1cState.version,
        applicable,
        pairCoherent,
        noraExists: Boolean(nora),
        backTopExists: Boolean(backTop),
        footerExists: Boolean(footer),
        bound: state.bound === true,
        documentResizeObserverCount:
          state.documentResizeObserverCount ?? null,
        geometryLifecycleEvents:
          state.geometryLifecycleEvents || [],
        noraThreshold:
          nora?.dataset?.cf43Threshold || null,
        noraState:
          nora?.dataset?.cf43ScrollState || null,
        noraProgress:
          nora?.dataset?.cf43ScrollProgress || null,
        backTopVisible:
          backTop?.classList?.contains('is-visible') || false,
        notApplicableReason:
          state.notApplicableReason || null
      };

      result.ok =
        pairCoherent &&
        result.documentResizeObserverCount === 0 &&
        (
          !applicable ||
          (
            result.bound === true &&
            GEOMETRY_EVENTS.every(eventName =>
              result.geometryLifecycleEvents.includes(eventName)
            )
          )
        );

      return result;
    };
  }

  function boot() {
    const nora = document.querySelector('.cf43-scroll-gated');
    const backTop = document.querySelector('.cf42-backtop');
    const footer =
      document.querySelector('.footer-group footer') ||
      document.querySelector('footer') ||
      document.querySelector('.footer-group');

    // P1-C R2: publish/debug BEFORE any early return.
    // If this optional HOME control pair is not rendered in the current HOME
    // composition, there is no ResizeObserver owner to consolidate.
    const initial = publishState(nora, backTop, footer, false);
    exposeDebug(nora, backTop, footer);

    if (!initial.pairCoherent) {
      document.documentElement.dataset.cfP1cHomeControls = 'PAIR_INCOMPLETE';
      return;
    }

    if (!initial.applicable) {
      document.documentElement.dataset.cfP1cHomeControls = 'NOT_RENDERED';
      return;
    }

    // Prevent duplicate bindings across Theme Editor section lifecycle events.
    if (
      nora.dataset.cfP1cControlsBound === '1' &&
      backTop.dataset.cfP1cControlsBound === '1'
    ) {
      publishState(nora, backTop, footer, true);
      exposeDebug(nora, backTop, footer);
      document.documentElement.dataset.cfP1cHomeControls = 'BOUND_EXISTING';
      return;
    }

    let ticking = false;

    function progress() {
      const max = Math.max(
        0,
        document.documentElement.scrollHeight - window.innerHeight
      );
      if (max <= 0) return 0;
      return Math.max(0, Math.min(1, window.scrollY / max));
    }

    function applyNora() {
      ticking = false;
      const p = progress();
      const show = p >= 0.75;
      nora.classList.toggle('is-scroll-visible', show);
      nora.setAttribute('aria-hidden', show ? 'false' : 'true');
      nora.tabIndex = show ? 0 : -1;
      nora.dataset.cf43ScrollState = show ? 'VISIBLE' : 'HIDDEN';
      nora.dataset.cf43ScrollProgress = p.toFixed(4);
    }

    function scheduleNora() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(applyNora);
    }

    function showBackTop(show) {
      backTop.classList.toggle('is-visible', !!show);
      backTop.setAttribute('aria-hidden', show ? 'false' : 'true');
      backTop.tabIndex = show ? 0 : -1;
    }

    applyNora();
    showBackTop(false);

    window.addEventListener('scroll', scheduleNora, { passive:true });
    window.addEventListener('resize', scheduleNora, { passive:true });

    // No ResizeObserver(document.documentElement).
    // Recalculate only on deterministic first-party lifecycle events.
    window.addEventListener('load', scheduleNora, { once:true });
    window.addEventListener(
      'canfoto:unified-product-card-ready',
      scheduleNora
    );
    window.addEventListener('canfoto:experience-change', scheduleNora);
    document.addEventListener('shopify:section:load', scheduleNora);

    if (footer && 'IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === footer) {
            showBackTop(entry.isIntersecting);
          }
        });
      }, { threshold:.01 }).observe(footer);
    } else if (footer) {
      const checkFooter = () => {
        const r = footer.getBoundingClientRect();
        showBackTop(
          r.top < window.innerHeight &&
          r.bottom > 0
        );
      };

      window.addEventListener('scroll', checkFooter, { passive:true });
      window.addEventListener('resize', checkFooter, { passive:true });
      checkFooter();
    }

    backTop.addEventListener('click', () => {
      const reduced =
        window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      window.scrollTo({
        top: 0,
        left: 0,
        behavior: reduced ? 'auto' : 'smooth'
      });
    });

    nora.dataset.cfP1cControlsBound = '1';
    backTop.dataset.cfP1cControlsBound = '1';

    publishState(nora, backTop, footer, true);
    exposeDebug(nora, backTop, footer);
    document.documentElement.dataset.cfP1cHomeControls = 'BOUND';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once:true });
  } else {
    boot();
  }

  // Theme editor can insert/remove the HOME hero after initial boot.
  // Re-run safely; duplicate binding is guarded by dataset markers.
  document.addEventListener('shopify:section:load', boot);
})();

/* ==========================================================================
   CANFOTO · E1 FINAL1 · R2J-H6
   SHOP THE LOOK · LIVE-NATIVE EVENT PARITY ONLY
   Mouseenter -> LIVE theme LookbookElement.init() (untouched).
   Click/focus/touch -> the same native LookbookElement.select(index).
   NO Flickity API calls. NO cell mutation. NO reloadCells. NO resize.
   ========================================================================== */
(() => {
  'use strict';
  if (window.__CANFOTO_E1_FINAL1_R2J_H6_SHOP_LOOK__) return;
  window.__CANFOTO_E1_FINAL1_R2J_H6_SHOP_LOOK__ = true;

  const VERSION = 'CANFOTO-E1-FINAL1-R2J-H6-SHOP-LOOK-LIVE-NATIVE-EVENT-PARITY-R1';
  const q = (s, r = document) => r.querySelector(s);
  const qa = (s, r = document) => [...r.querySelectorAll(s)];

  function bind(shop) {
    if (!shop || shop.dataset.cfH6Bound === '1') return;
    const lookbook = q('lookbook-element', shop);
    if (!lookbook || typeof lookbook.select !== 'function') return;

    qa('.hotspot', lookbook).forEach((hotspot, index) => {
      const selectNative = () => lookbook.select(index);
      hotspot.addEventListener('click', selectNative);
      hotspot.addEventListener('focusin', selectNative);
      hotspot.addEventListener('touchstart', selectNative, { passive: true });
    });

    shop.dataset.cfH6Bound = '1';
  }

  function boot() {
    qa('body.template-index shop-the-look').forEach(bind);
    window.CANFOTO_E1_FINAL1_R2J_H6_SHOP_LOOK_STATE = {
      version: VERSION,
      count: qa('body.template-index shop-the-look[data-cf-h6-bound="1"]').length,
      behaviorOwner: 'THEME_JS_NATIVE_SHOPTHELOOK_LOOKBOOK_CAROUSEL'
    };
  }

  window.CanFotoShopLookH6 = {
    version: VERSION,
    boot,
    snapshot() {
      const shop = q('body.template-index shop-the-look');
      const lookbook = q('lookbook-element', shop || document);
      const carousel = q('carousel-element', shop || document);
      return {
        bound: shop?.dataset.cfH6Bound === '1',
        hotspotCount: lookbook ? qa('.hotspot', lookbook).length : 0,
        productCardCount: carousel ? qa('.product-card', carousel).length : 0,
        unifiedCardsInsideShopLook: carousel ? qa('.cf-unified-product-card', carousel).length : 0,
        selectedIndex: carousel?.carousel?.selectedIndex ?? null,
        flickityCells: carousel?.carousel?.cells?.length ?? null
      };
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  window.debugCanFotoShopLookDeferP2R1 = function(){
    const shop=q('shop-the-look');
    const carousel=shop?q('carousel-element',shop):null;
    const cards=carousel?qa('.product-card',carousel):[];
    const desktop=matchMedia('(min-width:1024px)').matches;
    const state=shop?.dataset.cfH7DeferredState||null;

    const result={
      sectionPresent:!!shop,
      carouselPresent:!!carousel,
      state,
      cardCount:cards.length,
      readyCount:cards.filter(c=>c.dataset.cfH7State==='READY').length,
      pendingCount:cards.filter(c=>c.dataset.cfH7State==='PENDING').length,
      untouchedCount:cards.filter(c=>!c.dataset.cfH7State).length,
      desktop,
      staleMobileStateOnDesktop:desktop && state==='MOBILE_NATIVE'
    };

    result.ok=!shop || (
      !!carousel &&
      cards.length>0 &&
      ['WAITING','LOADING','READY','MOBILE_NATIVE'].includes(state) &&
      result.staleMobileStateOnDesktop===false
    );

    console.table(result);
    return result;
  };

})();

/* ==========================================================================
   CANFOTO PERFORMANCE P1-A
   SHOP THE LOOK · SERVER-FIRST / STABLE-DOM OWNER

   H6 native LookbookElement + CarouselElement + Flickity remain behavior owners.
   H7 Collection-parity copy is now rendered by Liquid in the initial HTML.
   This runtime performs NO product JSON fetch and NO product-card content rebuild.
   It publishes owner/readiness state only.
   ========================================================================== */
(() => {
  'use strict';
  if (window.__CANFOTO_P1A_SHOP_LOOK_SERVER_FIRST__) return;
  window.__CANFOTO_P1A_SHOP_LOOK_SERVER_FIRST__ = true;

  const VERSION='CANFOTO-PERFORMANCE-P1-A-SHOP-LOOK-SERVER-FIRST-STABLE-DOM-R1';
  const H7_PRESENTATION='CANFOTO-E1-FINAL1-R2J-H7-SHOP-LOOK-COLLECTION-CARD-PARITY-R1';
  const DESKTOP_MQ=matchMedia('(min-width:1024px)');
  const q=(s,r=document)=>r.querySelector(s);
  const qa=(s,r=document)=>[...r.querySelectorAll(s)];

  function publish(shop){
    if(!shop)return null;
    const desktop=DESKTOP_MQ.matches;
    const cards=qa('carousel-element .product-card',shop);
    const serverCards=cards.filter(card=>
      card.dataset.cfShoplookServerFirst==='1' &&
      !!q('.cf-shoplook-server-copy',card) &&
      !!q('.cf-shoplook-native-copy',card)
    );

    cards.forEach(card=>{
      if(!serverCards.includes(card))return;
      if(desktop){
        card.dataset.cfH7State='READY';
        card.dataset.cfH7Source='LIQUID_SERVER_FIRST';
      }else{
        delete card.dataset.cfH7State;
        card.dataset.cfH7Source='LIQUID_SERVER_FIRST_MOBILE_NATIVE';
      }
    });

    shop.dataset.cfH7DeferredState=desktop?'READY':'MOBILE_NATIVE';
    shop.dataset.cfP1aShoplookOwner='LIQUID_SERVER_FIRST_STABLE_DOM';

    const state={
      version:VERSION,
      h7PresentationOwner:H7_PRESENTATION,
      desktop,
      deferredState:shop.dataset.cfH7DeferredState,
      nativeBehaviorOwner:'CANFOTO-E1-FINAL1-R2J-H6-SHOP-LOOK-LIVE-NATIVE-EVENT-PARITY-R1',
      contentOwner:'LIQUID_SERVER_FIRST',
      cardCount:cards.length,
      serverFirstCount:serverCards.length,
      readyCount:desktop?serverCards.length:0,
      failedCount:0,
      productJsonFetchOwner:'NONE',
      domContentReplacementOwner:'NONE'
    };

    window.CANFOTO_E1_FINAL1_R2J_H7_SHOP_LOOK_STATE=state;
    window.CANFOTO_P1A_SHOP_LOOK_SERVER_FIRST_STATE=state;
    window.dispatchEvent(new CustomEvent('canfoto:shop-look-card-parity-ready',{detail:state}));
    return state;
  }

  function boot(){
    if(!document.body.classList.contains('template-index'))return;
    const shop=q('shop-the-look');
    if(!shop)return;
    publish(shop);
    const sync=()=>publish(shop);
    if(DESKTOP_MQ.addEventListener)DESKTOP_MQ.addEventListener('change',sync);
    else DESKTOP_MQ.addListener(sync);
  }

  window.CanFotoShopLookH7={
    version:VERSION,
    performanceVersion:VERSION,
    boot,
    snapshot(){
      const shop=q('shop-the-look');
      return shop?publish(shop):null;
    }
  };

  window.debugCanFotoShopLookDeferP2R1=function(){
    const shop=q('shop-the-look');
    const state=shop?publish(shop):null;
    const result={
      sectionPresent:!!shop,
      carouselPresent:!!q('carousel-element',shop||document),
      state:state?.deferredState||null,
      cardCount:state?.cardCount||0,
      readyCount:state?.readyCount||0,
      pendingCount:0,
      untouchedCount:0,
      desktop:state?.desktop??DESKTOP_MQ.matches,
      staleMobileStateOnDesktop:false,
      serverFirstCount:state?.serverFirstCount||0,
      productJsonFetchOwner:state?.productJsonFetchOwner||'NONE'
    };
    result.ok=!shop || (
      result.carouselPresent &&
      result.cardCount>0 &&
      result.serverFirstCount===result.cardCount &&
      ['READY','MOBILE_NATIVE'].includes(result.state)
    );
    console.table(result);
    return result;
  };

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});
  else boot();
})();

/* ==========================================================================
   CANFOTO · E1 FINAL1 · R2J-H16
   SHOP THE FEED · MOBILE CARD TAP BRIDGE
   OWNER: CANFOTO-E1-FINAL1-R2J-H16-SHOP-FEED-MOBILE-TAP-BRIDGE-R1

   PURPOSE:
   Native theme opens a feed drawer from .media-card__button.
   On mobile the old Home presentation layer hid that control, leaving the
   visible card/product thumbnails without a reliable opening route.
   This bridge preserves the native drawer owner and simply forwards a mobile
   card/thumb tap to the card's existing native action control.
   ========================================================================== */
(function(){
  'use strict';

  const VERSION='CANFOTO-E1-FINAL1-R2J-H16-SHOP-FEED-MOBILE-TAP-BRIDGE-R1';
  const MQ='(max-width: 860px)';
  let lastTouchX=0;
  let lastTouchY=0;
  let moved=false;

  function isMobile(){
    return !!(window.matchMedia && window.matchMedia(MQ).matches);
  }

  function inFeedCard(node){
    return node && node.closest
      ? node.closest('body.template-index #MainContent .shop-the-feed .media-card')
      : null;
  }

  function nativeAction(card){
    return card ? card.querySelector('.media-card__button') : null;
  }

  function shouldIgnore(target){
    return !!target.closest(
      '.media-card__button, a[href]:not(.media-card__button), ' +
      'input, select, textarea, [contenteditable="true"], ' +
      '.deferred-poster, video-media button'
    );
  }

  function openCard(card, source){
    const action=nativeAction(card);
    if(!action || action.getAttribute('aria-disabled')==='true') return false;

    try{
      action.click();
      document.documentElement.dataset.cfShopFeedMobileOpen='H16';
      window.CANFOTO_E1_FINAL1_R2J_H16_SHOP_FEED_STATE={
        version:VERSION,
        status:'READY',
        lastSource:source||'card',
        nativeActionTag:action.tagName,
        nativeActionControls:action.getAttribute('aria-controls')||'',
        mutationContract:{
          nativeDrawerOwner:'PRESERVED',
          feedData:'NO_TOUCH',
          productTruth:'NO_TOUCH',
          shopTheLook:'NO_TOUCH',
          collection:'NO_TOUCH',
          scoring:'NONE',
          ranking:'NONE'
        }
      };
      return true;
    }catch(err){
      console.error('CANFOTO H16 Shop Feed mobile open bridge:',err);
      return false;
    }
  }

  document.addEventListener('touchstart',function(e){
    if(!isMobile() || !inFeedCard(e.target) || !e.touches || !e.touches[0]) return;
    lastTouchX=e.touches[0].clientX;
    lastTouchY=e.touches[0].clientY;
    moved=false;
  },{passive:true,capture:true});

  document.addEventListener('touchmove',function(e){
    if(!isMobile() || !e.touches || !e.touches[0]) return;
    if(Math.abs(e.touches[0].clientX-lastTouchX)>12 ||
       Math.abs(e.touches[0].clientY-lastTouchY)>12){
      moved=true;
    }
  },{passive:true,capture:true});

  document.addEventListener('click',function(e){
    if(!isMobile()) return;

    const card=inFeedCard(e.target);
    if(!card || moved) return;

    /* Existing CTA/link keeps its native behavior. */
    if(e.target.closest('.media-card__button')) return;

    /* Product thumbnail buttons have no independent mobile route in the
       current native card. Forward those taps to the same feed drawer. */
    const thumb=e.target.closest('.horizontal-product__media');
    if(thumb){
      e.preventDefault();
      e.stopPropagation();
      openCard(card,'product-thumbnail');
      return;
    }

    /* Any otherwise non-interactive point of the visible card opens it. */
    if(shouldIgnore(e.target)) return;

    e.preventDefault();
    openCard(card,'card-surface');
  },true);

  document.documentElement.dataset.cfShopFeedMobileBridge='H16';
  window.CANFOTO_E1_FINAL1_R2J_H16_SHOP_FEED_STATE={
    version:VERSION,
    status:'READY',
    mutationContract:{
      nativeDrawerOwner:'PRESERVED',
      feedData:'NO_TOUCH',
      productTruth:'NO_TOUCH',
      shopTheLook:'NO_TOUCH',
      collection:'NO_TOUCH',
      scoring:'NONE',
      ranking:'NONE'
    }
  };
})();

